export default value => (value ? JSON.parse(value || {}) : {});
